import {MutableRefObject, useEffect, useState} from "react";

/**
 * Returns height of LAST child element of passed REF regardless if it's hidden via overflow:hidden
 * @param ref
 * @return {number}
 * @example
 * //This will return entire <div> height
 *  <Container ref={ref}>
 *      <div>
 *          {children}
 *      </div>
 *  </Container>
 */
export const useChildHeight = (ref: MutableRefObject<any>) => {
    const [height, setHeight] = useState(0)
    useEffect(() => {
        const {lastChild} = ref.current;
        const {clientHeight} = lastChild;
        setHeight(clientHeight)
    }, []);

    return height
}